import { lazy } from 'react';
import { MFA_FACTOR } from '@helpers/constants';

const RegistrationPage = lazy(() => import('./components/pages/Registration/RegistrationPage'));
const LoginPage = lazy(() => import('./components/pages/Login/LoginPage'));
const DashboardPage = lazy(() => import('./components/pages/Dashboard/DashboardPage'));
const OktaMFAPage = lazy(() => import('./components/pages/OktaMFA/OktaMFAPage'));
const ForgotPasswordPage = lazy(() => import('./components/pages/ForgotPassword/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('./components/pages/ResetPasswordPage/ResetPasswordPage'));
const AccountInfoPage = lazy(() => import('./components/pages/AccountInfo/AccountInfoPage'));
const CompanyDetailsPage = lazy(() => import('./components/pages/CompanyDetails/CompanyDetailsPage'));
const ObsoleteBrowserPage = lazy(() => import('./components/pages/ObsoleteBrowserPage/ObsoleteBrowserPage'));
const LogoutPage = lazy(() => import('./components/pages/Logout/LogoutPage'));
const AuthenticatedComponent = lazy(() => import('./components/shared/AuthenticatedComponent/AuthenticatedComponent'));
const DunsSetPassword = lazy(() => import('./components/pages/DunsSetPassword/DunsSetPassword'));
const DunsSigninPage = lazy(() => import('./components/pages/DunsLanding/Signin/DunsSigninView'));
const FreeGadInstructions = lazy(() => import('./components/GetADuns/FreeGad/FreeGadInstructions'));
const DunsRegisterPage = lazy(() => import('./components/pages/DunsLanding/Signup/RegisterPage'));
const DunsVerifyEmailPage = lazy(() => import('./components/pages/DunsLanding/VerifyEmail/VerifyEmail'));
const Agreement = lazy(() => import('./components/pages/Agreement/Agreement'));

const routes = [
    {
        path: '/login',
        component: <LoginPage />,
        pageId: 'login',
        isSecure: false,
        title: 'Login',
        showCPLHeader: true,
        showFooter: true,
    },
    {
        path: '/social-signup',
        component: <RegistrationPage />,
        pageId: 'signup',
        isSecure: false,
        title: 'Sign Up',
        showFooter: true,
    },
    {
        path: '/logout',
        component: <LogoutPage />,
        pageId: 'logout',
        isSecure: false,
        title: 'Logout',
        showCPLHeader: true,
        showFooter: true,
    },
    {
        path: '/forgot-password',
        component: <ForgotPasswordPage />,
        pageId: 'forgotPassword',
        isSecure: false,
        title: 'duns-application:forgot',
        showCPLHeader: true,
        showFooter: false,
    },
    {
        path: '/signin',
        component: <DunsSigninPage />,
        pageId: 'signIn',
        isSecure: false,
        title: 'duns-application:signin',
        showFooter: false,
    },
    {
        path: '/signup',
        component: <DunsRegisterPage />,
        pageId: 'signup',
        isSecure: false,
        title: 'duns-application:signup',
        showFooter: false,
    },
    {
        path: '/verify-email',
        component: <DunsVerifyEmailPage />,
        pageId: 'verifyemail',
        isSecure: false,
        title: 'duns-application:email',
        showFooter: false,
    },
    {
        path: '/set-password',
        component: <DunsSetPassword />,
        pageId: 'setPassword',
        isSecure: false,
        title: 'duns-application:set-password',
        showCPLHeader: false,
        showFooter: false,
    },
    {
        path: '/duns-application',
        component: <FreeGadInstructions />,
        pageId: 'dunsApplicationFormPage',
        isSecure: true,
        title: 'duns-application:application',
        showCPLHeader: false,
        showFooter: false,
    },
    {
        path: '/accountInfo',
        component: <AccountInfoPage />,
        pageId: 'accounts',
        isSecure: true,
        title: 'Account',
        showCPLHeader: true,
        showFooter: true,
    },
    {
        path: '/companyDetails',
        component: <CompanyDetailsPage />,
        pageId: 'companyDetails',
        isSecure: true,
        title: 'Company Details',
        showCPLHeader: true,
        showFooter: true,
    },
    {
        path: '/resetPassword',
        component: <ResetPasswordPage />,
        pageId: 'resetPassword',
        isSecure: false,
        title: 'Reset Password',
        showCPLHeader: true,
        showFooter: false,
    },
    {
        path: '/obsoleteBrowser',
        component: <ObsoleteBrowserPage />,
        pageId: 'obsoleteBrowser',
        isSecure: false,
        title: 'Obsolete Browser',
        showCPLHeader: true,
        showFooter: true,
    },
    {
        path: '/continueRegistration',
        component: <ResetPasswordPage />,
        pageId: 'resetPassword',
        isSecure: false,
        title: 'Continue Registration',
        showCPLHeader: true,
        showFooter: true,
    },
    {
        path: '/confirmRegistration',
        component: <ResetPasswordPage />,
        pageId: 'resetPassword',
        isSecure: false,
        title: 'Confirm Registration',
        showCPLHeader: true,
        showFooter: true,
    },
    {
        path: '/agreement',
        component: <Agreement />,
        pageId: 'agreement',
        isSecure: true,
        title: 'Product Level Agreements',
        showCPLHeader: false,
        showFooter: false,
    },
    ...MFA_FACTOR ? [{
        path: '/mfa',
        component: <OktaMFAPage />,
        pageId: 'mfa',
        isSecure: true,
        title: 'MFA',
        showCPLHeader: true,
    }] : [],
    {
        path: '/',
        component: <AuthenticatedComponent><DashboardPage /></AuthenticatedComponent>,
        pageId: 'dashboard',
        isSecure: true,
        title: 'Home',
        showCPLHeader: true,
        showFooter: true,
    },

];
export default routes;
